import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { Auth } from '@/models/auth.model';
import { Actions, BazaarState } from '@/models/store.model';
import { computed } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {

const store = useStore<BazaarState>();

const auth = computed<Auth>(() => store.state.auth);

const logout = () => {
  store.dispatch(Actions.Logout);
};

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (auth.value.isUser)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _createElementVNode("a", {
            href: "#",
            class: "dark",
            onClick: _withModifiers(logout, ["prevent"])
          }, "Uitloggen"),
          _cache[0] || (_cache[0] = _createTextVNode(" - "))
        ]))
      : _createCommentVNode("", true),
    (!auth.value.isUser)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createVNode(_component_RouterLink, { to: "/login" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Inloggen")
            ])),
            _: 1,
            __: [1]
          }),
          _cache[2] || (_cache[2] = _createTextVNode(" - "))
        ]))
      : _createCommentVNode("", true),
    _cache[3] || (_cache[3] = _createElementVNode("a", {
      href: "https://www.front-crafter.nl",
      target: "_blank"
    }, "Front Crafter", -1)),
    _cache[4] || (_cache[4] = _createTextVNode(" - 2024 "))
  ]))
}
}

})